export default {
	getByUserId(uid, cb, ecb) {
		this.http
			.get(`/oauth/getByUserId/${uid}`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getByType(type, cb) {
		this.http
			.get(`/oauth/getByType/${type}`)
			.then((response) => cb && cb(response))
	},
	unbind(type, cb, ecb) {
		this.http
			.get(`/oauth/unbind/${type}`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	bind(form, cb, ecb) {
		this.http
			.post(`/oauth/bind/${type}`, form)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	aliCodeAuth(code, cb, ecb) {
		this.http
			.post(`/oauth/aliCodeAuth/${code}`)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	bindApple(code, cb, ecb) {
		this.http
			.get(`/oauth/bindApple/${code}`)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	bindGithub(token, cb, ecb) {
		this.http
			.get(`/oauth/bindGithub/${token}`)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	bindWechat(code, uid, cb, ecb) {
		this.http
			.get(`/oauth/bindWechat/${code}/${uid}`)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	merge(fromuid, touid, type, cb, ecb) {
		this.http
			.get(`/oauth/merge/${fromuid}/${touid}/${type}`)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	loginByTouchId(params, cb, ecb) {
		this.http
			.get(`/oauth/loginByTouchId`, { params })
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	wechatLoginCheck(token, cb, ecb) {
		this.http
			.get(`/oauth/wechatlogincheck/${token}`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getWechatOpenId(cb, ecb) {
		this.http
			.get(`/oauth/getWechatOpenId`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getWechatOpenIdByCode(code, cb, ecb) {
		this.http
			.get(`/oauth/getWechatOpenIdByCode/${code}`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	}
}
